/**
 * Zero-JS data-attribute handlers for SmartResponse.
 *
 * Provides:
 *   data-smart-dialog  — confirm dialogs (submit form, AJAX, navigate)
 *   data-smart-ajax    — simple AJAX requests on click
 *   data-smart-toggle  — toggle state via POST
 */

let initialized = false;

export function initDataAttributeHandlers() {
    if (initialized) return;
    initialized = true;

    $(document).on('click', '[data-smart-dialog]', handleSmartDialog);
    $(document).on('click', '[data-smart-ajax]', handleSmartAjax);
    $(document).on('click', '[data-smart-toggle]', handleSmartToggle);
}

/**
 * data-smart-dialog handler.
 *
 * On click, shows a confirmation dialog. On confirm:
 *   1. If data-form is set → submits that form via Smart.utils.submitForm
 *   2. Else if data-url is set → sends AJAX request
 *   3. Else if element is <a> with href → navigates
 *   4. Else → submits closest parent form
 */
function handleSmartDialog(e) {
    e.preventDefault();

    const $el = $(this);
    const title = $el.data('title') || window.Smart.lang.are_you_sure || 'Are you sure?';
    const text = $el.data('text') || '';
    const icon = $el.data('icon') || 'warning';
    const confirmBtn = $el.data('confirm-btn') || window.Smart.lang.yes || 'Yes';
    const cancelBtn = $el.data('cancel-btn') || window.Smart.lang.cancel || 'Cancel';
    const confirmColor = $el.data('confirm-color') || '';

    // Use SweetAlert2 if available, otherwise native confirm
    if (typeof window.Swal !== 'undefined') {
        const swalOptions = {
            title: title,
            text: text,
            icon: icon,
            showCancelButton: true,
            confirmButtonText: confirmBtn,
            cancelButtonText: cancelBtn,
            reverseButtons: true,
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary ms-2',
                cancelButton: 'btn btn-secondary',
            },
        };

        if (confirmColor) {
            swalOptions.customClass.confirmButton = 'btn ms-2';
            swalOptions.didRender = function () {
                const btn = Swal.getConfirmButton();
                if (btn) {
                    btn.style.backgroundColor = confirmColor;
                    btn.style.borderColor = confirmColor;
                    btn.style.color = '#fff';
                }
            };
        }

        Swal.fire(swalOptions).then((result) => {
            if (result.isConfirmed) {
                executeDialogAction($el);
            }
        });
    } else {
        // Native fallback
        if (confirm(title + (text ? '\n\n' + text : ''))) {
            executeDialogAction($el);
        }
    }
}

function executeDialogAction($el) {
    const formSelector = $el.data('form');
    const url = $el.data('url');
    const ajaxMethod = $el.data('ajax-method') || 'POST';

    if (formSelector) {
        const form = $(formSelector)[0] || $el.closest('form')[0];
        if (form) {
            window.Smart.utils.submit_form(form);
        }
        return;
    }

    if (url) {
        performAjaxRequest($el, url, ajaxMethod);
        return;
    }

    // If it's a link, navigate
    const href = $el.attr('href');
    if (href && href !== '#') {
        window.location.href = href;
        return;
    }

    // Fallback: submit closest form
    const closestForm = $el.closest('form')[0];
    if (closestForm) {
        window.Smart.utils.submit_form(closestForm);
    }
}

/**
 * data-smart-ajax handler.
 */
function handleSmartAjax(e) {
    e.preventDefault();

    const $el = $(this);
    const method = $el.data('smart-ajax') || 'POST';
    const url = $el.attr('href') || $el.data('url');

    if (!url) {
        console.warn('[Smart] data-smart-ajax requires href or data-url');
        return;
    }

    performAjaxRequest($el, url, method);
}

/**
 * data-smart-toggle handler.
 */
function handleSmartToggle(e) {
    e.preventDefault();

    const $el = $(this);
    const url = $el.data('url');

    if (!url) {
        console.warn('[Smart] data-smart-toggle requires data-url');
        return;
    }

    performAjaxRequest($el, url, 'POST', function () {
        $el.toggleClass('active');
    });
}

/**
 * Shared AJAX request helper for data-attribute handlers.
 * CSRF is handled globally by $.ajaxSetup in Smart.initAjax().
 */
function performAjaxRequest($el, url, method, onSuccess) {
    const successToast = $el.data('success-toast');
    const buttonHtml = window.Smart.utils.disable_button($el);

    $.ajax({
        url: url,
        method: method,
        complete: function (jqXHR) {
            window.Smart.utils.enable_button($el, buttonHtml);
            window.Smart.utils.ajax_complete_handler(jqXHR);

            if (jqXHR.status >= 200 && jqXHR.status < 300) {
                if (successToast) {
                    window.Smart.utils.process_actions([{
                        name: 'toast',
                        data: {
                            type: 'success',
                            title: window.Smart.lang.success || 'Success',
                            message: successToast,
                        }
                    }]);
                }

                if (onSuccess) {
                    onSuccess(jqXHR);
                }
            }
        }
    });
}

export default { initDataAttributeHandlers };
